export const AUTH_CONFIG = {
    domain: "mdc-rbac.auth0.com",
    roleUrl: "https://dealerinspire/roles",
    clientId: "Olm1b975TCffwRgN5UxWAMgWcjbZRuKY",
    callbackUrl: "http://localhost:3000/callback",
};
